export const postDSPMesage = () => {
    // @ts-ignore
    window?.AndroidInterface?.postMessage("DSP");
    // @ts-ignore
    window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("DSP");     
    // @ts-ignore
    window?.ReactNativeWebView?.postMessage("DSP")
    // @ts-ignore
    window?.top?.postMessage("DSP")
}

